import React from 'react';
import { useTranslation } from "react-i18next";

const CookieBanner = ({ onAcceptAll, onNecessaryOnly, onSettings }) => {
      const { t } = useTranslation();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        maxWidth: '380px',
        width: 'calc(100% - 40px)',
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
        zIndex: 1060,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        color: '#333',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h5 style={{ fontWeight: 600, margin: 0, fontSize: '1.1rem' }}>{t("banner.title")}
</h5>
        <button
          onClick={onNecessaryOnly}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            lineHeight: '1',
            cursor: 'pointer',
            color: '#888',
          }}
        >
          &times;
        </button>
      </div>
      <p style={{ fontSize: '0.9rem', color: '#666', lineHeight: '1.5', margin: '0 0 20px 0' }}>
          {t("banner.intro")}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={onAcceptAll}
            style={{
              flex: 1,
              padding: '10px',
              border: 'none',
              borderRadius: '6px',
              backgroundColor: '#28a745',
              color: 'white',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
          {t("banner.acceptAll")}
          </button>
          <button
            onClick={onNecessaryOnly}
            style={{
              flex: 1,
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              backgroundColor: '#6c757d',
              color: 'white',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
          {t("banner.necessaryOnly")}
          </button>
        </div>
        <button
          onClick={onSettings}
          style={{
            width: '100%',
            padding: '10px',
            border: 'none',
            borderRadius: '6px',
            backgroundColor: '#007bff',
            color: 'white',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
                    {t("banner.settings")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
